/**
 * @generated SignedSource<<670a6bfc29a8fb1be34d89f5fd710a7e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type categorizePage_Query$variables = {
  from?: string | null | undefined;
  perspectiveId?: string | null | undefined;
};
export type categorizePage_Query$data = {
  readonly categorizePage: {
    readonly categories: ReadonlyArray<{
      readonly color: string;
      readonly id: string;
      readonly name: string;
      readonly parent: {
        readonly id: string;
      } | null | undefined;
      readonly pnlLine: string | null | undefined;
      readonly rank: number;
    }>;
    readonly perspective: {
      readonly id: string;
      readonly name: string;
    };
    readonly stakeholders: ReadonlyArray<{
      readonly allocations: ReadonlyArray<{
        readonly amountCents: number | null | undefined;
        readonly category: {
          readonly color: string;
          readonly id: string;
          readonly name: string;
        };
        readonly id: string;
        readonly kind: string;
        readonly ordinal: number | null | undefined;
        readonly sliceType: string | null | undefined;
        readonly weight: number;
      }>;
      readonly stakeholder: {
        readonly id: string;
        readonly internal: boolean;
        readonly name: string;
      };
      readonly totalSpend: number;
    }>;
  };
  readonly perspectivesExport: string;
};
export type categorizePage_Query = {
  response: categorizePage_Query$data;
  variables: categorizePage_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "from"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "perspectiveId"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "perspectivesExport",
  "storageKey": null
},
v3 = [
  {
    "kind": "Variable",
    "name": "from",
    "variableName": "from"
  },
  {
    "kind": "Variable",
    "name": "perspectiveId",
    "variableName": "perspectiveId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "Perspective",
  "kind": "LinkedField",
  "name": "perspective",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v5/*: any*/)
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "Category",
  "kind": "LinkedField",
  "name": "categories",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    (v5/*: any*/),
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rank",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pnlLine",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Category",
      "kind": "LinkedField",
      "name": "parent",
      "plural": false,
      "selections": [
        (v4/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "Stakeholder",
  "kind": "LinkedField",
  "name": "stakeholder",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "internal",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalSpend",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "Categorization",
  "kind": "LinkedField",
  "name": "allocations",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "weight",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sliceType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "amountCents",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ordinal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "kind",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Category",
      "kind": "LinkedField",
      "name": "category",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        (v5/*: any*/),
        (v7/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "categorizePage_Query",
    "selections": [
      (v2/*: any*/),
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "CategorizePage",
        "kind": "LinkedField",
        "name": "categorizePage",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CategorizeStakeholder",
            "kind": "LinkedField",
            "name": "stakeholders",
            "plural": true,
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "categorizePage_Query",
    "selections": [
      (v2/*: any*/),
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "CategorizePage",
        "kind": "LinkedField",
        "name": "categorizePage",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CategorizeStakeholder",
            "kind": "LinkedField",
            "name": "stakeholders",
            "plural": true,
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fb5aebc8dc69db8c0f1277277cfff802",
    "id": null,
    "metadata": {},
    "name": "categorizePage_Query",
    "operationKind": "query",
    "text": "query categorizePage_Query(\n  $perspectiveId: ID\n  $from: String\n) {\n  perspectivesExport\n  categorizePage(perspectiveId: $perspectiveId, from: $from) {\n    perspective {\n      id\n      name\n    }\n    categories {\n      id\n      name\n      color\n      rank\n      pnlLine\n      parent {\n        id\n      }\n    }\n    stakeholders {\n      stakeholder {\n        id\n        name\n        internal\n      }\n      totalSpend\n      allocations {\n        id\n        weight\n        sliceType\n        amountCents\n        ordinal\n        kind\n        category {\n          id\n          name\n          color\n        }\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "c436b0922cda929539e0a98c6b7d5457";

export default node;
